<template>
  <div class="no_nav_height">
    <div class="row f-row mb-2">
      <div
        class="markets-chart-title col col-12"
        style="text-align: center!important;"
      >
        {{
          selectedTable.charAt(0).toUpperCase() +
            selectedTable.slice(1).replace("_2", "")
        }}:
        <span style="color: var(--textactive); font-size: 1.1rem">
          {{ Analytics["userSelections"]["selectionStr"] }}</span
        >
      </div>
    </div>
    <!-- Company/Portfolio/Asset Selection -->
    <div class="row f-row mt-2 mb-2" style="padding: 0 5px 0 5px!important;">
      <div class="col col-12">
        <CompanyPortProdSelector
          :Analytics="Analytics"
          :colorTheme="colorTheme"
          :companies="Analytics['companies']"
          :isManagement="true"
          :loadingAll="Analytics['loading']['management']"
          :companyParametersReady="companyParametersReady"
          :managementAvailableCol="managementAvailableCol"
          :managementSelectedCol="managementSelectedCol"
          :selectedTable="selectedTable"
          :selectedUnit="selectedUnit"
          :dataSelectedTable="tableData"
          @eventOnUserAsset="onUserAsset"
          @eventOnUserColumns="onUserColumns"
          @eventOnUserCompany="onUserCompany"
          @eventOnUserFetchExpand="onUserFetchExpand"
          @eventOnUserFetchData="onUserFetchManagementData"
          @eventOnUserPortfolio="onUserPortfolio"
          @eventOnUserSelectUnit="onUserSelectUnit"
          @eventOnUserSpotChange="onUserSpotChange"
        />
      </div>
    </div>
    <ManagementTable
      v-if="true"
      :Analytics="Analytics"
      :managementLoading="Analytics['loading']['management']"
      :managementSelectedCol="managementSelectedCol"
      :selectedTable="selectedTable"
      :selectedUnit="selectedUnit"
      @eventAvailableColumns="(val) => (managementAvailableCol = val)"
      @eventSelectedColumns="(val) => (managementSelectedCol = val)"
      @eventTableData="handleTableData"
    />
    <Messages :modal_message="Analytics['loading']" />
  </div>
</template>

<script>
import { format, timeFormat } from "d3";
import { todayWithoutTime } from "@/_core/_helpers/_helpers";
import { formatPercent } from "@/_core/_helpers/_parametric_tools";
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";
import CompanyPortProdSelector from "./CompanyPortProdSelector";
import ManagementTable from "@/components/analytics/ManagementTable.vue";
import Messages from "../modals/Messages.vue";

export default {
  name: "ManagementConsolidations",
  components: {
    CompanyPortProdSelector,
    ManagementTable,
    Messages,
  },
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics(),
    },
    colorTheme: { required: true, type: Boolean, default: true },
    companyParametersReady: { required: true, type: Boolean, default: false },
    processData: { required: true },
    selectedTable: { required: true, default: "strategies" },
    selectedUnit: { required: true, default: "contracts" },
  },
  data() {
    return {
      managementAvailableCol: ["a", "b", "c"],
      managementSelectedCol: ["a"],
      tableData: [],
    };
  },
  mounted() {
    let dat;
    if (this.initialDate === null) {
      dat = todayWithoutTime();
      dat.setMonth(dat.getMonth() - 1, 0);
      this.newInitialDate = dat;
    } else {
      this.newInitialDate = this.initialDate;
    }
    if (this.finalDate === null) {
      dat = todayWithoutTime();
      dat.setMonth(dat.getMonth(), 0);
      this.newFinalDate = dat;
    } else {
      this.newFinalDate = this.finalDate;
    }
    this.newInitialSpot = this.initialSpot;
    this.newFinalSpot = this.finalSpot;
  },
  computed: {
    newFinalDate: {
      get: function() {
        return this.Analytics["valuation"]["finalDate"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserFinalDate", newValue);
      },
    },
    newInitialDate: {
      get: function() {
        return this.Analytics["valuation"]["initialDate"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserInitialDate", newValue);
      },
    },
    newSelectedCompanies: {
      get: function() {
        return this.Analytics["userSelections"]["selectedCompanies"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserCompany", newValue);
      },
    },
    newPortfolios() {
      return this.Analytics["userSelections"]["portfolios"];
    },
    newSelectedPortfolios: {
      get: function() {
        return this.Analytics["userSelections"]["selectedPortfolios"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserPortfolio", newValue);
      },
    },
    newAssets() {
      return this.Analytics["userSelections"]["underlying"];
    },
    newSelectedAsset: {
      get: function() {
        return this.Analytics["userSelections"]["selectedUnderlying"];
      },
      set: function(newValue) {
        this.$emit("eventOnUserUnderlying", newValue);
      },
    },
  },
  watch: {},
  methods: {
    onUserSelectUnit(val) {
      this.$emit("eventOnUserSelectUnit", val);
    },
    onUserSpotChange(val) {
      this.$emit("eventOnUserSpotChange", val);
    },
    download() {
      console.log("download...");
    },
    handleTableData(val) {
      this.tableData = val;
    },
    // ==== emits
    onUserCompany(newValue) {
      this.$emit("eventOnUserCompany", newValue);
    },
    onUserPortfolio(newValue) {
      this.$emit("eventOnUserPortfolio", newValue);
    },
    onUserAsset(newValue) {
      this.$emit("eventOnUserAsset", newValue);
    },
    onUserColumns(newCols) {
      this.managementSelectedCol = newCols;
    },
    onUserFetchManagementData() {
      this.$emit("eventOnUserFetchManagementData");
    },
    onUserFetchExpand() {
      this.$emit("eventOnUserFetchExpand");
    },
  },
  filters: {
    valuationFormat: function(val) {
      if (!val) {
        return "-";
      } else {
        return val === 0 ? "-" : format(",.0f")(val);
      }
    },
    numberFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",")(Math.round(val));
    },
    priceFormat: function(val) {
      return val === null || val === 0 ? "-" : format(",.6r")(val);
    },
    percFormat: function(val) {
      return val === null || val === 0 ? "-" : formatPercent(val);
    },
    dateFormat: function(val) {
      return val === null ||
        val === "" ||
        val === 0 ||
        +val < +new Date(1980, 1, 1)
        ? "-"
        : timeFormat("%d %b %y")(val);
    },
  },
};
</script>

<style scoped></style>
